import React, { useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import MaterialIcon from '@material/react-material-icon';
import PropTypes from 'prop-types';
import { AuthContext } from '../../context/AuthContext';

import './SideMenu.scss';

const SideMenu = ({ title, desc, menus, content, selectedMenu, handleMenu, inPopup = false }) => {
  const { auth } = useContext(AuthContext);
  const userRoles = auth?.roles;

  const BodyElement = () => {
    return (
      <div className="admin-body">
        <div className="left">
          <div className="admin-menu">
            {menus?.map(
              (menu) =>
                menu.allowedRoles?.find((role) => userRoles?.includes(role)) && (
                  <div
                    key={menu.id}
                    className={`menu-item ${selectedMenu === menu.name && 'active'}`}
                    onClick={() => handleMenu(menu.name)}
                  >
                    <MaterialIcon className="my-icon" icon={menu.icon} />
                    {menu.title}
                    {menu.badge && <div className="ready" />}
                    {menu.count > 0 && <div className="menu-badge"></div>}
                  </div>
                ),
            )}
          </div>
        </div>
        <div className="right">{content}</div>
      </div>
    );
  };

  return (
    <>
      <div className="side-menu">
        <div className="admin-panel-header">
          <h4 className="fw-bold">{title}</h4>
          <span>{desc}</span>
        </div>
      </div>
      {!inPopup ? (
        <Card className="rounded-4">
          <CardBody>
            <BodyElement />
          </CardBody>
        </Card>
      ) : (
        <BodyElement />
      )}
    </>
  );
};

SideMenu.propTypes = {
  title: PropTypes.string,
  desc: PropTypes.string,
  menus: PropTypes.array,
  content: PropTypes.node,
  selectedMenu: PropTypes.string,
  handleMenu: PropTypes.func,
  inPopup: PropTypes.bool,
};

export default SideMenu;
